import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "cozynest_owner_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const BUSINESS = {
  name: "The Cozy Nest",
  hosts: "Elisa e Gianna",
  nightlyRate: 100,
  cleaningFee: 30,
  maxGuests: 4,
  whatsapp: "393520487257",
  email: "thecozynest.apartment@gmail.com",
  phoneDisplay: "+39 352 048 7257 / +39 340 726 9509",
  addressArea: "Via Capanne 13, Santa Maria a Monte (PI)",
  lat: 43.6413,
  lng: 10.6916,
  carRental: "https://noleggioautopontedera.com",
  carRentalEmail: "info@centroautopontedera.it",
};
